import React, { useEffect, useState } from "react";
import "./style.css";
import axios from "axios";
import { FaLock, FaUser, FaEye, FaEyeSlash } from "react-icons/fa";
import HeaderFa from "../header-fa";
import FooterFa from "../footer-fa";
import Musicobo0 from "../../../assets/Musicobo-1.6.6-0.png";
import Musicobo1 from "../../../assets/Musicobo-fa-1.6.6-1.png";
import Musicobo2 from "../../../assets/Musicobo-fa-1.6.6-2.png";
import Musicobo3 from "../../../assets/Musicobo-fa-1.6.6-3.png";
import Musicobo4 from "../../../assets/Musicobo-fa-1.6.6-4.png";
import Musicobo5 from "../../../assets/Musicobo-fa-1.6.6-5.png";
import Musicobo6 from "../../../assets/Musicobo-fa-1.6.6-6.png";

const engText = require("../../../utils/musicTherapyEngTexts.js");
const faText = require("../../../utils/musicTherapyFaTexts.js");

function MusicTherapy(props) {
  const [usernameLogin, setUsernameLogin] = useState("");
  const [passwordLogin, setPasswordLogin] = useState("");
  const [usernameEmpty, setUsernameEmpty] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isReceiving, setIsReceiving] = useState(false);
  const [userOrPassError, setUserOrPassError] = useState(false);
  const [showMainError, setShowMainError] = useState(false);
  const [nameError, setNameError] = useState(true);
  const [familyError, setFamilyError] = useState(true);
  const [phoneError, setPhoneError] = useState(true);
  const [phoneNumberCountError, setPhoneNumberCountError] = useState(true);
  const [ageError, setAgeError] = useState(true);
  const [priceError, setPriceError] = useState(true);
  const [mainError, setMainError] = useState(true);
  const [childName, setChildName] = useState("");
  const [familyName, setFamilyName] = useState("");
  const [childAge, setChildAge] = useState(0);
  const [mobileNumber, setMobileNumber] = useState("");
  const [musicTherapyText, setmusicTherapyText] = useState(faText);
  const [countryCode, setCountryCode] = useState(props.languageInput);
  const [childGender, setchildGender] = useState("boy");
  const [priceAmount, setPriceAmount] = useState("");
  const [sendMessage, setSendMessage] = useState(
    "Hello,I'mInMusicoboTicketPage"
  );

  useEffect(() => {
    handleRedirect();
  }, []);

  const handleRedirect = async () => {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: sendMessage,
    });
  };

  const childNameInput = (event) => {
    if (event.target.value == "") setNameError(true);
    else setNameError(false);
    if (
      event.target.value != "" &&
      !phoneError &&
      !ageError &&
      !priceError &&
      !familyError
    )
      setMainError(false);
    else setMainError(true);
    setChildName(event.target.value);
  };

  const childFamilyInput = (event) => {
    setFamilyName(event.target.value);
  };

  const mobileNumberInput = (event) => {
    if (event.target.value == "") setPhoneError(true);
    else setPhoneError(false);
    if (
      !nameError &&
      !familyError &&
      event.target.value != "" &&
      9 < event.target.value.length < 13 &&
      !ageError &&
      !priceError
    )
      setMainError(false);
    else setMainError(true);
    if (
      (mobileNumber.length != 0 && mobileNumber.length < 9) ||
      mobileNumber.length > 13
    )
      setPhoneNumberCountError(true);
    else setPhoneNumberCountError(false);
    setMobileNumber(event.target.value);
  };

  const childAgeInput = (event) => {
    if (event.target.value == 0) setAgeError(true);
    else setAgeError(false);
    if (
      !priceError &&
      9 < mobileNumber.length < 13 &&
      !nameError &&
      !phoneError &&
      event.target.value != ""
    )
      setMainError(false);
    else setMainError(true);
    setChildAge(event.target.value);
  };

  const childGenderCheck = (event) => {
    setchildGender(event.target.value);
  };

  const priceInput = (event) => {
    if (event.target.value == 0) setPriceError(true);
    else setPriceError(false);

    if (
      !nameError &&
      9 < mobileNumber.length < 13 &&
      !phoneError &&
      !ageError &&
      event.target.value != ""
    )
      setMainError(false);
    else setMainError(true);
    setPriceAmount(event.target.value);
  };

  const submitHandler = async (event) => {
    event.preventDefault();
    if (usernameLogin == "") setUsernameEmpty(true);
    else setUsernameEmpty(false);
    if (usernameEmpty == false) {
      setIsReceiving(true);
      const result = await axios.post("https://request.kidiar.com/login/request", {
        username: usernameLogin,
        password: passwordLogin,
      });
      if (result.data.auth == false) {
        setIsReceiving(false);
        setUserOrPassError(true);
      } else if (result.data.auth == true) {
        localStorage.setItem("token", result.data.token);
        window.location.href = "/fa/panel/games/musicobo";
      }
    }
  };

  return (
    <div>
      <HeaderFa />
      <div className="music-therapy-container">
        <div className="music-therapy-page">
          <div className="left-music-therapy">
            <div className="d-flex flex-column">
              <img
                src={Musicobo0}
                style={{ width: "94%", marginLeft: "3%", marginRight: "3%" }}
              ></img>
              <div
                className="d-flex"
                style={{ width: "94%", marginLeft: "3%", marginRight: "3%" }}
              >
                <img
                  src={Musicobo1}
                  style={{
                    width: "23.5%",
                    marginTop: "1%",
                    marginLeft: "1%",
                    marginRight: "0%",
                  }}
                ></img>
                <img
                  src={Musicobo2}
                  style={{
                    width: "23.5%",
                    marginTop: "1%",
                    marginLeft: "1%",
                    marginRight: "1%",
                  }}
                ></img>
                <img
                  src={Musicobo3}
                  style={{
                    width: "23.5%",
                    marginTop: "1%",
                    marginLeft: "1%",
                    marginRight: "1%",
                  }}
                ></img>
                <img
                  src={Musicobo4}
                  style={{
                    width: "23.5%",
                    marginTop: "1%",
                    marginLeft: "0%",
                    marginRight: "1%",
                  }}
                ></img>
              </div>
            </div>

            <h1>{musicTherapyText[0]}</h1>
            <p>{musicTherapyText[1]}</p>
          </div>

          <div className="right-music-therapy">
            <div className="form">
              <div className="field-container">
                <form
                  action=""
                  className="signin-form"
                  onSubmit={submitHandler}
                >
                  <h2 className="signin-title">ورود به حساب کاربری</h2>
                  <div className="input-field d-ltr">
                    <FaUser />
                    <input
                      type="text"
                      placeholder="نام کاربری"
                      onChange={(event) => {
                        setUsernameLogin(event.target.value);
                      }}
                    ></input>
                  </div>
                  <div
                    className="input-field d-ltr d-flex"
                    style={{ position: "relative" }}
                  >
                    <FaLock />
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="رمز عبور"
                      onChange={(event) => {
                        setPasswordLogin(event.target.value);
                      }}
                    ></input>
                    {showPassword ? (
                      <FaEyeSlash
                        onClick={() => setShowPassword(!showPassword)}
                      ></FaEyeSlash>
                    ) : (
                      <FaEye
                        onClick={() => setShowPassword(!showPassword)}
                      ></FaEye>
                    )}
                  </div>
                  <button
                    type="submit"
                    className="btn solid d-flex justify-content-center align-items-center"
                  >
                    {isReceiving ? (
                      <div className="spinner"></div>
                    ) : (
                      <p>ورود</p>
                    )}
                  </button>
                  <div className="error-message">
                    {usernameEmpty && (
                      <label>*لطفا نام کاربری را وارد کنید</label>
                    )}
                    {userOrPassError && (
                      <label>*اطلاعات وارد شده اشتباه می باشد</label>
                    )}
                  </div>
                </form>
              </div>
              <div className="error-text-main">
                {showMainError ? <p>{musicTherapyText[21]}</p> : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterFa />
    </div>
  );
}

export default MusicTherapy;
